import { record } from 'fp-ts';
import { values } from '@mews/fp';

import { DEFAULT_ADULT_COUNT } from '../../constants';
import { ApplicationState } from '../../types';
import { WithServiceId } from '../../types/selectors/selectorPropTypes';
import { getEnterpriseDatesOccupancy } from '../../views/dates/slices/selectors';
import { isDefaultAgeCategory } from '../entities/ageCategories/selectors';
import { getServiceEnterpriseId } from '../entities/services/selectors';
import { getInitialOccupancyData } from './selectors';

export const getCategoriesOccupancyData = (state: ApplicationState, { serviceId }: WithServiceId) => {
    const enterpriseId = getServiceEnterpriseId(state, { serviceId });
    const datesOccupancy = enterpriseId != null ? getEnterpriseDatesOccupancy(state, { enterpriseId }) : null;

    const hasAnyOccupancyData = datesOccupancy != null && !record.isEmpty(datesOccupancy);
    const occupancyData = hasAnyOccupancyData
        ? values(datesOccupancy).map(({ ageCategoryId, personCount }) => ({
              ageCategoryId,
              personCount: Math.max(0, personCount),
          }))
        : getInitialOccupancyData(state, { serviceId });

    const isEmptyOccupancy = occupancyData.every((occupancy) => occupancy.personCount === 0);
    if (isEmptyOccupancy) {
        return occupancyData.map(({ ageCategoryId }) => ({
            ageCategoryId,
            personCount: isDefaultAgeCategory(state, { ageCategoryId }) ? DEFAULT_ADULT_COUNT : 0,
        }));
    }
    return occupancyData;
};
